import {
	MessageBar,
	MessageBarBody,
} from "@fluentui/react-components";
import { useIntl } from "react-intl";
import {
	AicLockState,
	useAicLockStore,
} from "@/common/stores/nonpersistingStores/aicLock";

export const AicLockBanner = () => {
	const intl = useIntl();
	const isAicLocked = useAicLockStore((state: AicLockState) => state.isAicLocked);

	if (!isAicLocked) {
		return null;
	}

	return (
		<MessageBar intent="warning">
			<MessageBarBody>
				{intl.formatMessage({ id: "AicLock.Banner" })}
			</MessageBarBody>
		</MessageBar>
	);
};
